var BraintreeCardAbstract = (function ($, _, PaymentProviderBase, braintree, CheckoutSettings, PromiseUtil) {

	// Abstract class for braintree card payment provider, never create instances!
	var BraintreeCardAbstract = PaymentProviderBase.extend({

        type: 'card',
        paymentOption: CheckoutSettings.PaymentOption.BrainTree,
        _supportedTypes: braintreeSupportedTypes.card,
		_supportedOrderTypes: braintreeSupportedOrderTypes.card,
        _supportedProviderType: CheckoutSettings.PaymentOption.BrainTree,

		initialize: function (attrs, opts) {
			this._init = new $.Deferred();

			this.braintree = opts.Braintree;
            this.hideErrors = !!opts.hideErrors;
            this.braintree.onSetupDone(this._init.resolve);
			this._logger = opts.logger;

		},

		// Abstract method.
		complete: function (method) {
			throw new Error("complete() method should be implemented");
		},

		prepayment: function () {
			if (PromiseUtil.isResolved(this._init)) {
				return this.braintree.hostedFields.getPayload();
			} else {
				return PromiseUtil.rejected();
			}
		}
	});

	return BraintreeCardAbstract;
})($, _, PaymentProviderBase, braintree, CheckoutSettings, PromiseUtil);
